(function () {
  if (window.__ssMenuEnhancementsInitialized) return;
  window.__ssMenuEnhancementsInitialized = true;

  function normalizePath(href) {
    try {
      var url = new URL(href, window.location.origin);
      return url.pathname.replace(/\/+$/, "") || "/";
    } catch (e) {
      return (href || "").replace(/\/+$/, "") || "/";
    }
  }

  function normalizeMenuKey(href) {
    var path = normalizePath(href || "");
    return path.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i, "") || "/";
  }

  function getMenuImageFromLink(link) {
    if (!(link instanceof HTMLAnchorElement)) return "";

    var explicit = link.getAttribute("data-menu-preview-image");
    if (explicit) return explicit;

    var fromInnerImage = link.querySelector("img");
    if (fromInnerImage && fromInnerImage.getAttribute("src")) {
      return fromInnerImage.getAttribute("src");
    }

    var href = normalizePath(link.getAttribute("href") || "");
    var map = window.SS_MENU_IMAGES || {};
    if (map[href]) return map[href];

    var hrefKey = normalizeMenuKey(href);
    for (var key in map) {
      if (!Object.prototype.hasOwnProperty.call(map, key)) continue;
      if (normalizeMenuKey(key) === hrefKey) return map[key] || "";
    }
    return "";
  }

  function getMenuMetaFromLink(link) {
    if (!(link instanceof HTMLAnchorElement)) return null;
    var href = normalizePath(link.getAttribute("href") || "");
    var dataMap = window.SS_MENU_DATA || {};
    var data = dataMap[href] || {};

    var image = getMenuImageFromLink(link);
    return {
      href: link.getAttribute("href") || "",
      image: image,
      priceFrom: data.priceFrom || "",
      title: (link.textContent || "").trim()
    };
  }

  function extractPriceString(value) {
    if (typeof value === "string") return value.trim();
    if (!value || typeof value !== "object") return "";
    var prioritizedKeys = [
      "fromPrice",
      "priceFrom",
      "lowestPrice",
      "minPrice",
      "minPriceFormatted",
      "from",
      "min",
      "lowest",
      "displayPrice"
    ];
    for (var k = 0; k < prioritizedKeys.length; k++) {
      var key = prioritizedKeys[k];
      if (typeof value[key] === "string" && value[key].trim()) return value[key].trim();
    }
    if (typeof value.price === "string") return value.price.trim();
    if (typeof value.formatted === "string") return value.formatted.trim();
    if (typeof value.formattedPrice === "string") return value.formattedPrice.trim();
    if (typeof value.priceFormatted === "string") return value.priceFormatted.trim();
    if (typeof value.minPriceFormatted === "string") return value.minPriceFormatted.trim();
    return "";
  }

  function getEmbedPriceFromCandidate(candidate, href) {
    if (!candidate) return "";

    var methods = [
      "getPriceForUrl",
      "getPriceByUrl",
      "getPriceForPath",
      "getPriceByPath",
      "getPrice",
      "priceForUrl",
      "priceForPath"
    ];

    for (var i = 0; i < methods.length; i++) {
      var method = methods[i];
      if (typeof candidate[method] === "function") {
        try {
          var result = candidate[method](href) || candidate[method](window.location.origin + href) || candidate[method](href.replace(/^\//, ""));
          if (result && typeof result.then === "function") continue;
          var extracted = extractPriceString(result);
          if (extracted) return extracted;
        } catch (e) {}
      }
    }

    var maps = ["prices", "pricesByUrl", "pricesByPath", "priceMap", "priceByUrl", "priceByPath"];
    for (var j = 0; j < maps.length; j++) {
      var map = candidate[maps[j]];
      if (map && typeof map === "object") {
        var mapped = extractPriceString(map[href]);
        if (mapped) return mapped;
      }
    }

    return "";
  }

  function getAsyncEmbedPrice(link, callback) {
    if (!(link instanceof HTMLAnchorElement)) return;
    var href = normalizePath(link.getAttribute("href") || "");
    var hrefAbs = window.location.origin + href;
    var hrefNoSlash = href.replace(/^\//, "");
    var candidates = [
      window.CustomPriceEmbed,
      window.customPriceEmbed,
      window.CUSTOM_PRICE_EMBED,
      window.__CUSTOM_PRICE_EMBED__,
      window.customPrice,
      window.CustomPrice
    ];
    var methods = [
      "getPriceForUrl",
      "getPriceByUrl",
      "getPriceForPath",
      "getPriceByPath",
      "getPrice",
      "priceForUrl",
      "priceForPath"
    ];

    for (var i = 0; i < candidates.length; i++) {
      var candidate = candidates[i];
      if (!candidate) continue;
      for (var j = 0; j < methods.length; j++) {
        var method = methods[j];
        if (typeof candidate[method] !== "function") continue;
        try {
          var result = candidate[method](href) || candidate[method](hrefAbs) || candidate[method](hrefNoSlash);
          if (result && typeof result.then === "function") {
            result
              .then(function (resolved) {
                var extracted = extractPriceString(resolved);
                if (extracted) callback(extracted);
              })
              .catch(function () {});
          }
        } catch (e) {}
      }
    }
  }

  function getEmbedFromDom(link) {
    if (!(link instanceof HTMLAnchorElement)) return "";
    var href = normalizePath(link.getAttribute("href") || "");

    var selectors = [
      '[data-custom-price][data-url="' + href + '"]',
      '[data-price-embed][data-url="' + href + '"]',
      '[data-custom-price-url="' + href + '"]',
      '[data-product-url="' + href + '"][data-price-from]',
      '[data-product-url="' + href + '"][data-price]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var node = document.querySelector(selectors[i]);
      if (!(node instanceof HTMLElement)) continue;
      var attrs = ["data-price-from", "data-from-price", "data-lowest-price", "data-min-price", "data-price"];
      for (var j = 0; j < attrs.length; j++) {
        var val = node.getAttribute(attrs[j]);
        if (val) return val.trim();
      }
    }

    return "";
  }

  function getPriceFromCustomEmbed(link) {
    if (!(link instanceof HTMLAnchorElement)) return "";
    var href = normalizePath(link.getAttribute("href") || "");

    var candidates = [
      window.CustomPriceEmbed,
      window.customPriceEmbed,
      window.CUSTOM_PRICE_EMBED,
      window.__CUSTOM_PRICE_EMBED__,
      window.customPrice,
      window.CustomPrice
    ];

    for (var i = 0; i < candidates.length; i++) {
      var price = getEmbedPriceFromCandidate(candidates[i], href);
      if (price) return price;
    }

    var fromDom = getEmbedFromDom(link);
    if (fromDom) return fromDom;

    return "";
  }

  function formatPriceFromLabel(price) {
    if (!price) return "";
    var template = (window.SS_MENU_I18N && window.SS_MENU_I18N.priceFromTemplate) || "From __PRICE__";
    return template.replace("__PRICE__", price);
  }

  function installRuntimeStyleOverrides() {
    if (document.getElementById("ss-menu-runtime-overrides")) return;
    var style = document.createElement("style");
    style.id = "ss-menu-runtime-overrides";
    style.textContent = [
      ".header-menu .menu-list__list-item > .menu-list__link{position:relative!important;}",
      ".header-menu .menu-list__list-item > .menu-list__link::before{content:''!important;position:absolute!important;left:50%!important;width:calc(100% - var(--gap-xl, 1.5rem))!important;max-width:calc(100% - var(--gap-xl, 1.5rem))!important;bottom:0.2rem!important;height:2px!important;background:#cea602!important;transform:translateX(-50%) scaleX(0)!important;transform-origin:center center!important;transition:transform 220ms ease!important;pointer-events:none!important;}",
      ".header-menu .menu-list__list-item > .menu-list__link:hover::before,.header-menu .menu-list__list-item > .menu-list__link:focus-visible::before,.header-menu .menu-list__list-item > .menu-list__link[aria-expanded='true']::before,.header-menu .menu-list__list-item:hover > .menu-list__link::before,.header-menu .menu-list__list-item:focus-within > .menu-list__link::before,.header-menu .menu-list__list-item > .menu-list__link[data-ss-active='true']::before,.header-menu .menu-list__list-item > .menu-list__link.ss-is-active::before{transform:translateX(-50%) scaleX(1)!important;}",
      "#header-component.ss-disable-header-underlay-open .header__underlay-open{height:0!important;min-height:0!important;opacity:0!important;pointer-events:none!important;}",
      "#header-component.ss-disable-header-underlay-open .header__underlay-open::after{content:none!important;display:none!important;box-shadow:none!important;}",
      "@keyframes ss-submenu-fade-down{from{opacity:0;transform:translateY(-8px);}to{opacity:1;transform:translateY(0);}}"
    ].join("");
    (document.head || document.documentElement).appendChild(style);
  }

  function ensureMobileDrawerThumbnails(scope) {
    var root = scope && typeof scope.querySelectorAll === "function" ? scope : document;
    var links = root.querySelectorAll(
      ".menu-drawer .menu-drawer__menu--childlist .menu-drawer__menu-item--child[href], .menu-drawer .menu-drawer__menu--childlist .menu-drawer__menu-item--parent[href]"
    );
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (!(link instanceof HTMLAnchorElement)) continue;
      if (link.querySelector(".ss-mobile-menu-thumb")) continue;

      var image = getMenuImageFromLink(link);
      if (!image) continue;

      var img = document.createElement("img");
      img.className = "ss-mobile-menu-thumb";
      img.src = image;
      img.alt = "";
      img.loading = "lazy";
      img.decoding = "async";

      link.classList.add("ss-mobile-has-thumb");
      var textNode = link.querySelector(".menu-drawer__menu-item-text");
      if (textNode && textNode.nextSibling) {
        link.insertBefore(img, textNode.nextSibling);
      } else {
        link.appendChild(img);
      }
    }
  }

  function scheduleEnsureMobileDrawerThumbnails(scope) {
    if (window.__ssMobileDrawerThumbRafId) cancelAnimationFrame(window.__ssMobileDrawerThumbRafId);
    window.__ssMobileDrawerThumbRafId = requestAnimationFrame(function () {
      ensureMobileDrawerThumbnails(scope || document);
      setTimeout(function () {
        ensureMobileDrawerThumbnails(scope || document);
      }, 80);
    });
  }

  function installMobileDrawerThumbnailObserver() {
    if (window.__ssMobileDrawerThumbObserverInstalled) return;
    window.__ssMobileDrawerThumbObserverInstalled = true;

    var shouldRefreshFromNode = function (node) {
      if (!(node instanceof Element)) return false;
      if (node.matches(".menu-drawer, .menu-drawer-container, .header__icon--summary, .menu-drawer__menu, .menu-drawer__menu-item")) return true;
      if (node.querySelector(".menu-drawer, .menu-drawer__menu, .menu-drawer__menu-item")) return true;
      return false;
    };

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (shouldRefreshFromNode(mutation.target)) {
          scheduleEnsureMobileDrawerThumbnails(document);
          return;
        }
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          if (shouldRefreshFromNode(mutation.addedNodes[j])) {
            scheduleEnsureMobileDrawerThumbnails(document);
            return;
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["open", "class", "style"]
    });

    document.addEventListener(
      "toggle",
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;
        if (target.closest(".menu-drawer, .menu-drawer-container")) {
          scheduleEnsureMobileDrawerThumbnails(document);
        }
      },
      true
    );
  }

  function ensurePreviewPanel(submenuInner) {
    var existing = submenuInner.querySelector(".ss-menu-preview__image");
    if (existing instanceof HTMLImageElement) {
      var legacyTitle = submenuInner.querySelector(".ss-menu-preview__title");
      if (legacyTitle instanceof HTMLElement) legacyTitle.remove();
      return existing;
    }

    submenuInner.classList.add("ss-compra-preview-enabled");

    var aside = document.createElement("aside");
    aside.className = "ss-menu-preview";

    var anchor = document.createElement("a");
    anchor.className = "ss-menu-preview__link";
    anchor.href = "#";

    var img = document.createElement("img");
    img.className = "ss-menu-preview__image is-empty";
    img.alt = "";
    img.loading = "lazy";

    var price = document.createElement("p");
    price.className = "ss-menu-preview__price";
    price.hidden = true;

    anchor.appendChild(img);
    aside.appendChild(anchor);
    aside.appendChild(price);
    submenuInner.appendChild(aside);
    return img;
  }

  function setPreviewFromLink(submenuInner, link) {
    if (!(submenuInner instanceof HTMLElement) || !(link instanceof HTMLAnchorElement)) return;
    var img = ensurePreviewPanel(submenuInner);
    var meta = getMenuMetaFromLink(link);
    if (!meta) return;

    var src = meta.image;
    if (!src) return;

    var hrefRaw = meta.href || "";
    if (submenuInner.getAttribute("data-ss-preview-href") === hrefRaw) return;
    submenuInner.setAttribute("data-ss-preview-href", hrefRaw);

    if (img.getAttribute("src") !== src) img.setAttribute("src", src);
    img.classList.remove("is-empty");
    img.alt = meta.title;

    var previewLink = submenuInner.querySelector(".ss-menu-preview__link");
    if (previewLink instanceof HTMLAnchorElement && meta.href) {
      previewLink.href = meta.href;
      previewLink.setAttribute("aria-label", meta.title);
    }

    // Render preview directly below the active level-2 link container.
    var previewAside = submenuInner.querySelector(".ss-menu-preview");
    var block = link.closest(".mega-menu__column > div") || link.parentElement;
    if (previewAside instanceof HTMLElement && block instanceof HTMLElement && previewAside.parentElement !== block) {
      block.appendChild(previewAside);
    }

    var priceNode = submenuInner.querySelector(".ss-menu-preview__price");
    if (priceNode instanceof HTMLElement) {
      var embedPrice = getPriceFromCustomEmbed(link);
      var chosenPrice = meta.priceFrom || embedPrice || "";
      var linkHref = meta.href || "";
      priceNode.setAttribute("data-preview-href", linkHref);
      if (chosenPrice) {
        priceNode.hidden = false;
        priceNode.textContent = formatPriceFromLabel(chosenPrice);
      } else {
        priceNode.hidden = true;
        priceNode.textContent = "";
      }

      getAsyncEmbedPrice(link, function (asyncPrice) {
        if (!asyncPrice) return;
        if (priceNode.getAttribute("data-preview-href") !== linkHref) return;
        if (meta.priceFrom) return;
        priceNode.hidden = false;
        priceNode.textContent = formatPriceFromLabel(asyncPrice);
      });
    }
  }

  function getSubmenuInnerFromTrigger(trigger) {
    if (!(trigger instanceof HTMLAnchorElement)) return null;
    var submenuId = trigger.getAttribute("aria-controls");
    if (!submenuId) return null;

    var item = trigger.closest(".menu-list__list-item");
    if (!(item instanceof HTMLElement)) return null;

    var escapedId = window.CSS && typeof window.CSS.escape === "function"
      ? window.CSS.escape(submenuId)
      : submenuId.replace(/[^a-zA-Z0-9\-_:.]/g, "\\$&");

    var submenuInner = item.querySelector("#" + escapedId + ".menu-list__submenu-inner");
    if (submenuInner instanceof HTMLElement) return submenuInner;

    var fallback = document.getElementById(submenuId);
    return fallback instanceof HTMLElement && fallback.classList.contains("menu-list__submenu-inner") ? fallback : null;
  }

  function isCompraTrigger(trigger) {
    if (!(trigger instanceof HTMLAnchorElement)) return false;
    var targets = window.SS_MENU_TARGETS && window.SS_MENU_TARGETS.compra ? window.SS_MENU_TARGETS.compra : null;
    var href = normalizePath(trigger.getAttribute("href") || "");
    var hrefKey = normalizeMenuKey(href);
    if (targets) {
      var urls = Array.isArray(targets.urls) ? targets.urls : [];
      for (var i = 0; i < urls.length; i++) {
        if (normalizeMenuKey(urls[i] || "") === hrefKey) return true;
      }
      var titles = Array.isArray(targets.titles) ? targets.titles : [];
      var text = (trigger.textContent || "").trim().toLowerCase();
      for (var j = 0; j < titles.length; j++) {
        if ((titles[j] || "").toLowerCase() === text) return true;
      }
    }
    var title = (trigger.textContent || "").trim().toLowerCase();
    if (/^(compra|shop|tienda|boutique|acheter)$/.test(title)) return true;
    return hrefKey === "/collections";
  }

  function initializeSubmenuPanel(trigger) {
    var submenuInner = getSubmenuInnerFromTrigger(trigger);
    if (!(submenuInner instanceof HTMLElement)) return;

    var isCompra = isCompraTrigger(trigger);
    enforceDropdownPanel(trigger, submenuInner, isCompra);
    normalizeCompraStructure(submenuInner);
    if (isCompra) {
      submenuInner.classList.add("ss-compra-preview-enabled");
      ensureAlignmentObserver(submenuInner);
    }
    enforceSubmenuAlignment(submenuInner);

    if (!isCompra) return;

    var firstLinkWithImage = null;
    var menuLinks = submenuInner.querySelectorAll(".mega-menu__link");
    for (var i = 0; i < menuLinks.length; i++) {
      var node = menuLinks[i];
      if (getMenuImageFromLink(node)) {
        firstLinkWithImage = node;
        break;
      }
    }

    if (firstLinkWithImage instanceof HTMLAnchorElement) {
      setPreviewFromLink(submenuInner, firstLinkWithImage);
    } else {
      ensurePreviewPanel(submenuInner);
    }

    scheduleStabilize(trigger, submenuInner, isCompra);
  }

  function scheduleStabilize(trigger, submenuInner, isCompra) {
    if (!(trigger instanceof HTMLAnchorElement) || !(submenuInner instanceof HTMLElement)) return;
    var delays = [0, 80, 220];
    for (var i = 0; i < delays.length; i++) {
      (function (delay) {
        setTimeout(function () {
          if (!document.contains(trigger) || !document.contains(submenuInner)) return;
          enforceDropdownPanel(trigger, submenuInner, isCompra);
          enforceSubmenuAlignment(submenuInner);
        }, delay);
      })(delays[i]);
    }
  }

  function enforceDropdownPanel(trigger, submenuInner, isCompra) {
    if (!(trigger instanceof HTMLAnchorElement) || !(submenuInner instanceof HTMLElement)) return;
    if (!window.matchMedia("(min-width: 750px)").matches) return;

    var listItem = trigger.closest(".menu-list__list-item");
    if (listItem instanceof HTMLElement) {
      listItem.style.setProperty("position", "relative", "important");
    }

    var submenu = submenuInner.closest(".menu-list__submenu");
    if (submenu instanceof HTMLElement) {
      submenu.style.setProperty("width", "max-content", "important");
      submenu.style.setProperty("min-width", isCompra ? "12rem" : "14rem", "important");
      submenu.style.setProperty("max-width", isCompra ? "min(14rem, 95vw)" : "min(24rem, 90vw)", "important");
      submenu.style.setProperty("left", "calc(var(--gap-xl, 1.5rem) / -2 - 20px)", "important");
      submenu.style.setProperty("right", "auto", "important");
      submenu.style.setProperty("padding-inline", "0", "important");
      submenu.style.setProperty("clip-path", "none", "important");
    }

    suppressGlobalMegaBackground();

    submenuInner.style.setProperty("max-height", "min(70vh, 38rem)", "important");
    submenuInner.style.setProperty("overflow", "auto", "important");
    submenuInner.style.setProperty("padding", "0.9rem 0.6rem 0.9rem 40px", "important");
    if (!isCompra) {
      submenuInner.style.setProperty("display", "block", "important");
    }

    var mega = submenuInner.querySelector(".mega-menu");
    if (mega instanceof HTMLElement) {
      mega.classList.remove("section--full-width-margin");
      mega.classList.remove("section--page-width");
      mega.classList.add("ss-dropdown-mega-menu");
      mega.style.setProperty("width", "auto", "important");
      mega.style.setProperty("min-width", "0", "important");
      mega.style.setProperty("display", "block", "important");
      mega.style.setProperty("padding", "0", "important");
      mega.style.setProperty("margin", "0", "important");
    }
    var megaGrid = submenuInner.querySelector(".mega-menu__grid");
    if (megaGrid instanceof HTMLElement) {
      megaGrid.style.setProperty("display", "block", "important");
      megaGrid.style.setProperty("width", "auto", "important");
      megaGrid.style.setProperty("grid-template-columns", "none", "important");
    }
  }

  function suppressGlobalMegaBackground() {
    var headerComponent = document.querySelector("#header-component");
    if (headerComponent instanceof HTMLElement) {
      headerComponent.classList.add("ss-disable-header-underlay-open");
      headerComponent.style.setProperty("--submenu-height", "0px", "important");
      headerComponent.style.setProperty("--submenu-max-height", "0px", "important");
      headerComponent.style.setProperty("--full-open-header-height", "0px", "important");
    }
    var overflowMenus = document.querySelectorAll(".header-menu .overflow-menu");
    for (var i = 0; i < overflowMenus.length; i++) {
      var menu = overflowMenus[i];
      if (!(menu instanceof HTMLElement)) continue;
      menu.style.setProperty("--submenu-height", "0px", "important");
      menu.style.setProperty("--submenu-max-height", "0px", "important");
    }
  }

  function restoreGlobalMegaBackground() {
    var headerComponent = document.querySelector("#header-component");
    if (headerComponent instanceof HTMLElement) {
      headerComponent.classList.remove("ss-disable-header-underlay-open");
      headerComponent.style.removeProperty("--submenu-height");
      headerComponent.style.removeProperty("--submenu-max-height");
      headerComponent.style.removeProperty("--full-open-header-height");
    }
    var overflowMenus = document.querySelectorAll(".header-menu .overflow-menu");
    for (var i = 0; i < overflowMenus.length; i++) {
      var menu = overflowMenus[i];
      if (!(menu instanceof HTMLElement)) continue;
      menu.style.removeProperty("--submenu-height");
      menu.style.removeProperty("--submenu-max-height");
    }
  }

  function ensureAlignmentObserver(submenuInner) {
    if (!(submenuInner instanceof HTMLElement)) return;
    if (submenuInner.__ssAlignmentObserverAttached) return;
    submenuInner.__ssAlignmentObserverAttached = true;

    var rafId = 0;
    var apply = function () {
      if (submenuInner.__ssApplyingAlignment) return;
      submenuInner.__ssApplyingAlignment = true;
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(function () {
        normalizeCompraStructure(submenuInner);
        enforceSubmenuAlignment(submenuInner);
        submenuInner.__ssApplyingAlignment = false;
      });
    };

    var observer = new MutationObserver(function () {
      apply();
    });
    observer.observe(submenuInner, { childList: true, subtree: true });
    submenuInner.__ssAlignmentObserver = observer;

    // Apply a few extra passes after opening to beat late style injections from theme scripts.
    apply();
    setTimeout(apply, 40);
    setTimeout(apply, 120);
    setTimeout(apply, 260);
  }

  function enforceSubmenuAlignment(submenuInner) {
    if (!(submenuInner instanceof HTMLElement)) return;
    var menuList = submenuInner.querySelector(".mega-menu__list");
    if (menuList instanceof HTMLElement) {
      menuList.style.setProperty("display", "block", "important");
      menuList.style.setProperty("grid-template-columns", "none", "important");
      menuList.style.setProperty("grid-column", "1 / -1", "important");
      menuList.style.setProperty("gap", "0", "important");
    }

    var columns = submenuInner.querySelectorAll(".mega-menu__column");
    for (var c = 0; c < columns.length; c++) {
      var col = columns[c];
      if (!(col instanceof HTMLElement)) continue;
      col.style.setProperty("display", "block", "important");
      col.style.setProperty("width", "100%", "important");
      col.style.setProperty("grid-column", "1 / -1", "important");
      col.style.setProperty("margin-bottom", "0.8rem", "important");
    }

    var lists = submenuInner.querySelectorAll(".mega-menu__column ul.list-unstyled");
    for (var i = 0; i < lists.length; i++) {
      var ul = lists[i];
      if (!(ul instanceof HTMLElement)) continue;
      ul.removeAttribute("style");
      ul.style.setProperty("column-count", "1", "important");
      ul.style.setProperty("columns", "1", "important");
      ul.style.setProperty("column-width", "auto", "important");
      ul.style.setProperty("column-gap", "0", "important");
      ul.style.setProperty("display", "block", "important");

      var items = ul.querySelectorAll("li");
      for (var j = 0; j < items.length; j++) {
        var li = items[j];
        if (!(li instanceof HTMLElement)) continue;
        li.removeAttribute("style");
        li.style.setProperty("break-after", "auto", "important");
        li.style.setProperty("break-inside", "avoid", "important");
        li.style.setProperty("-webkit-column-break-after", "auto", "important");
        li.style.setProperty("page-break-inside", "avoid", "important");
      }
    }
  }

  function normalizeCompraStructure(submenuInner) {
    if (!(submenuInner instanceof HTMLElement)) return;

    var menuList = submenuInner.querySelector(".mega-menu__list");
    if (!(menuList instanceof HTMLElement)) return;

    var columns = [];
    for (var i = 0; i < menuList.children.length; i++) {
      var child = menuList.children[i];
      if (child instanceof HTMLElement && child.classList.contains("mega-menu__column")) {
        columns.push(child);
      }
    }
    for (var i = 0; i < columns.length; i++) {
      var column = columns[i];
      if (!(column instanceof HTMLElement)) continue;
      if (column.getAttribute("data-ss-processed") === "true") continue;

      var blocks = [];
      for (var j = 0; j < column.children.length; j++) {
        var inner = column.children[j];
        if (inner instanceof HTMLElement) {
          blocks.push(inner);
        }
      }

      if (blocks.length <= 1 && blocks[0] instanceof HTMLElement) {
        var nested = [];
        for (var n = 0; n < blocks[0].children.length; n++) {
          var child = blocks[0].children[n];
          if (child instanceof HTMLElement) {
            nested.push(child);
          }
        }
        if (nested.length > 1) {
          blocks = nested;
        }
      }

      if (blocks.length <= 1) {
        column.setAttribute("data-ss-processed", "true");
        continue;
      }

      for (var j = 1; j < blocks.length; j++) {
        var block = blocks[j];
        if (!(block instanceof HTMLElement)) continue;

        var newColumn = document.createElement("li");
        newColumn.className = "mega-menu__column";
        newColumn.appendChild(block);
        menuList.insertBefore(newColumn, column.nextSibling);
      }

      column.className = "mega-menu__column";
      column.setAttribute("data-ss-processed", "true");
    }
  }

  function installDebugHelpers() {
    if (window.SS_MENU_DEBUG && window.SS_MENU_DEBUG.inspectCompra) return;
    window.SS_MENU_DEBUG = window.SS_MENU_DEBUG || {};
    window.SS_MENU_DEBUG.inspectCompra = function () {
      var compraTriggers = document.querySelectorAll(".header-menu .menu-list__link[aria-controls]");
      var submenus = document.querySelectorAll(".menu-list__submenu-inner.ss-compra-preview-enabled");
      var first = submenus[0];
      if (!(first instanceof HTMLElement)) {
        return {
          count: 0,
          message: "No compra submenu found",
          triggerCandidates: compraTriggers.length,
          targets: window.SS_MENU_TARGETS && window.SS_MENU_TARGETS.compra ? window.SS_MENU_TARGETS.compra : null
        };
      }
      var menuList = first.querySelector(".mega-menu__list");
      var columns = first.querySelectorAll(".mega-menu__column");
      var lists = first.querySelectorAll(".mega-menu__column ul");
      var firstColumn = columns[0];
      return {
        count: submenus.length,
        menuList: !!menuList,
        columns: columns.length,
        lists: lists.length,
        firstColumnChildren: firstColumn ? firstColumn.children.length : 0,
        firstColumnHtml: firstColumn ? firstColumn.innerHTML.slice(0, 500) : ""
      };
    };
    window.SS_MENU_DEBUG.forceAlignCompra = function () {
      var submenus = document.querySelectorAll(".menu-list__submenu-inner.ss-compra-preview-enabled");
      for (var i = 0; i < submenus.length; i++) {
        var submenu = submenus[i];
        normalizeCompraStructure(submenu);
        enforceSubmenuAlignment(submenu);
      }
      return window.SS_MENU_DEBUG.inspectCompra();
    };
    window.SS_MENU_DEBUG.inspectHeaderMenuState = function () {
      var header = document.querySelector("#header-component");
      var overflow = document.querySelector("header-menu .overflow-menu");
      var openUnderlay = header ? header.querySelector(".header__underlay-open") : null;
      var closedUnderlay = header ? header.querySelector(".header__underlay-closed") : null;
      var openLinks = document.querySelectorAll(".header-menu .menu-list__link[aria-expanded='true']");
      var computedHeader = header ? getComputedStyle(header) : null;
      var computedOpenUnderlay = openUnderlay ? getComputedStyle(openUnderlay) : null;
      var computedClosedUnderlay = closedUnderlay ? getComputedStyle(closedUnderlay) : null;

      return {
        hasHeader: !!header,
        openLinks: openLinks.length,
        headerVars: computedHeader
          ? {
              submenuHeight: computedHeader.getPropertyValue("--submenu-height").trim(),
              fullOpenHeaderHeight: computedHeader.getPropertyValue("--full-open-header-height").trim(),
              headerHeight: computedHeader.getPropertyValue("--header-height").trim()
            }
          : null,
        underlays: {
          hasOpen: !!openUnderlay,
          hasClosed: !!closedUnderlay,
          openHeight: computedOpenUnderlay ? computedOpenUnderlay.height : null,
          closedHeight: computedClosedUnderlay ? computedClosedUnderlay.height : null
        },
        overflowInlineStyle: overflow ? overflow.getAttribute("style") : null
      };
    };
  }

  function initMenuEnhancements(scope) {
    var root = scope && typeof scope.querySelectorAll === "function" ? scope : document;
    installRuntimeStyleOverrides();
    scheduleEnsureMobileDrawerThumbnails(root);
    var headers = root.querySelectorAll(".header-menu");
    for (var h = 0; h < headers.length; h++) {
      var header = headers[h];
      if (header instanceof HTMLElement) {
        header.classList.add("ss-menu-dropdown-mode");
        if (!header.__ssActiveClearBound) {
          header.__ssActiveClearBound = true;
          header.addEventListener("mouseleave", function (event) {
            var current = event.currentTarget;
            if (current instanceof HTMLElement) clearTopLevelActive(current);
          });
        }
      }
    }
    var triggers = root.querySelectorAll(".header-menu .menu-list__link[aria-controls]");
    for (var i = 0; i < triggers.length; i++) {
      var trigger = triggers[i];
      if (trigger instanceof HTMLAnchorElement) {
        initializeSubmenuPanel(trigger);
      }
    }
    stabilizeOpenSubmenus(root);
  }

  function stabilizeOpenSubmenus(scope) {
    var root = scope && typeof scope.querySelectorAll === "function" ? scope : document;
    var openTriggers = root.querySelectorAll(".header-menu .menu-list__link[aria-controls][aria-expanded='true']");
    for (var i = 0; i < openTriggers.length; i++) {
      var trigger = openTriggers[i];
      if (trigger instanceof HTMLAnchorElement) {
        setTopLevelActive(trigger);
        initializeSubmenuPanel(trigger);
      }
    }
  }

  function setTopLevelActive(trigger) {
    if (!(trigger instanceof HTMLAnchorElement)) return;
    var menu = trigger.closest(".header-menu");
    if (!(menu instanceof HTMLElement)) return;
    menu.classList.add("ss-menu-dropdown-mode");
    var links = menu.querySelectorAll(".menu-list__link");
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (!(link instanceof HTMLAnchorElement)) continue;
      var isActive = link === trigger;
      link.setAttribute("data-ss-active", isActive ? "true" : "false");
      link.classList.toggle("ss-is-active", isActive);
    }
  }

  function clearTopLevelActive(menu) {
    if (!(menu instanceof HTMLElement)) return;
    var links = menu.querySelectorAll(".menu-list__link");
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (!(link instanceof HTMLAnchorElement)) continue;
      link.setAttribute("data-ss-active", "false");
      link.classList.remove("ss-is-active");
    }
    var hasOpenLink = !!document.querySelector(".header-menu .menu-list__link[aria-expanded='true']");
    if (!hasOpenLink) restoreGlobalMegaBackground();
  }

  function clearAllTopLevelActive() {
    var menus = document.querySelectorAll(".header-menu");
    for (var i = 0; i < menus.length; i++) {
      clearTopLevelActive(menus[i]);
    }
    var hasOpenLink = !!document.querySelector(".header-menu .menu-list__link[aria-expanded='true']");
    if (!hasOpenLink) restoreGlobalMegaBackground();
  }

  document.addEventListener("pointerover", function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest(".header-menu")) {
      clearAllTopLevelActive();
      return;
    }

    var topLink = target.closest(".header-menu .menu-list__link");
    if (topLink instanceof HTMLAnchorElement) {
      setTopLevelActive(topLink);
    }

    var trigger = target.closest(".header-menu .menu-list__link[aria-controls]");
    if (trigger instanceof HTMLAnchorElement && trigger.getAttribute("aria-expanded") !== "true") {
      initializeSubmenuPanel(trigger);
    }

    var link = target.closest(".header-menu .menu-list__submenu-inner.ss-compra-preview-enabled .mega-menu__link");
    if (!(link instanceof HTMLAnchorElement)) return;

    var submenuInner = link.closest(".menu-list__submenu-inner.ss-compra-preview-enabled");
    if (!(submenuInner instanceof HTMLElement)) return;
    setPreviewFromLink(submenuInner, link);
  });

  document.addEventListener("focusin", function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var topLink = target.closest(".header-menu .menu-list__link");
    if (topLink instanceof HTMLAnchorElement) {
      setTopLevelActive(topLink);
    }

    var trigger = target.closest(".header-menu .menu-list__link[aria-controls]");
    if (trigger instanceof HTMLAnchorElement && trigger.getAttribute("aria-expanded") !== "true") {
      initializeSubmenuPanel(trigger);
    }

    var link = target.closest(".header-menu .menu-list__submenu-inner.ss-compra-preview-enabled .mega-menu__link");
    if (!(link instanceof HTMLAnchorElement)) return;

    var submenuInner = link.closest(".menu-list__submenu-inner.ss-compra-preview-enabled");
    if (!(submenuInner instanceof HTMLElement)) return;
    setPreviewFromLink(submenuInner, link);
  });

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var topLink = target.closest(".header-menu .menu-list__link");
    if (topLink instanceof HTMLAnchorElement) {
      setTopLevelActive(topLink);
    }

    var trigger = target.closest(".header-menu .menu-list__link[aria-controls]");
    if (trigger instanceof HTMLAnchorElement) {
      setTimeout(function () {
        initializeSubmenuPanel(trigger);
        scheduleEnsureMobileDrawerThumbnails(document);
      }, 0);
    }

    var drawerTrigger = target.closest(".header__icon--summary, .menu-drawer__menu-item, .menu-drawer__back-button");
    if (drawerTrigger instanceof Element) {
      setTimeout(function () {
        scheduleEnsureMobileDrawerThumbnails(document);
      }, 0);
    }
  });

  installDebugHelpers();
  installMobileDrawerThumbnailObserver();
  initMenuEnhancements(document);
  document.addEventListener("DOMContentLoaded", function () {
    initMenuEnhancements(document);
  });
  document.addEventListener("shopify:section:load", function (event) {
    initMenuEnhancements(event.target);
  });
})();
